import Swiper from 'swiper/bundle';

function readOptions(wrap, root) {
  let data = {};
  try {
    data = JSON.parse(wrap.getAttribute('data-options') || '{}');
  } catch (_) {}

  const opts = {
    loop: !!data.loop,
    speed: Number(data.speed) || 600
  };

  if (data.autoplay) {
    opts.autoplay = { delay: Number(data.delay) || 4500, disableOnInteraction: false };
  }

  const pag = root.querySelector('.swiper-pagination');
  if (pag) {
    opts.pagination = { el: pag, clickable: true };
  }

  return opts;
}

export function initHeroSwipers(scope = document) {
  scope.querySelectorAll('[data-hero-swiper-root]').forEach((root) => {
    const wrap = root.querySelector('.js-hero-swiper');
    if (!wrap) return;

    if (wrap.__swiper && typeof wrap.__swiper.destroy === 'function') {
      wrap.__swiper.destroy(true, true);
    }

    const opts = readOptions(wrap, root);
    wrap.__swiper = new Swiper(wrap, opts);
  });
}
